/**
*  Date    : 2021/04/19
*  Author  : lbb1811
*  Declare : book
*/
import Immutable from 'seamless-immutable';

import bookcenter from '@/api/bookcenter';
import tradecenter from '@/api/tradecenter';
import { EMPTY_PAGE_BEAN } from '@/constants/common';
import readercenter from '@/api/readercenter';
import exercisebook from '@/api/exercisebook';

import page from './utils/page';

export default {
  namespace: 'book',
  state: Immutable({
    collectionList: EMPTY_PAGE_BEAN,
    bookShelfPageBean: EMPTY_PAGE_BEAN,
    seriesBookPageBean: EMPTY_PAGE_BEAN,
    openFoodLists: [],
    recommendListPageBean: EMPTY_PAGE_BEAN,
    footPrintListPageBean: EMPTY_PAGE_BEAN,
    myResourcePageBean: EMPTY_PAGE_BEAN,
    isRaysOpen: true, // 跳转小程序开关状态 小睿h5默认开
    searchBookPageBean: EMPTY_PAGE_BEAN,
    bookListPageBean: EMPTY_PAGE_BEAN, // 推荐书单
    coursePageBean: EMPTY_PAGE_BEAN, // 推荐课程
    resourcePageBean: EMPTY_PAGE_BEAN, // 资源广场搜索结果列表
    goodsPageBean: EMPTY_PAGE_BEAN, // 打印机商品列表
    gradeLabelData: {}, //用户年级和是否是教辅信息
    xiaoRuiAppIds: [], // 跳转到小睿伴学的应用 appIds
    bookSourceType: 1 // 书籍来源 1代表小瑞伴学，0代表伴学乐园
  }),
  reducers: {
    update: (state, { data, field }) => {
      return state.merge({ [field]: data });
    },
    updatePageBean: (state, { data, field }) => {
      const pageBean = Immutable.merge(page(state[field]).append(data));
      return state.merge({ [field]: pageBean });
    },
    // 一行两个
    update2In1PageBean: (state, { data, field }) => {
      let list = [];
      for(let i = 0; i < data.recordList.length; i += 2) {
        list.push(data.recordList.slice(i, i + 2));
      }
      data.recordList = list;
      const pageBean = Immutable.merge(page(state[field]).append(data));
      return state.merge({ [field]: pageBean });
    },
    // 重新组装recommendList数据
    updateRecommendList: (state, { data, field }) => {
      let newData = [];
      for(let i = 0, len = data.recordList.length; i < len; i += 3) {
        newData.push(data.recordList.slice(i, i + 3));
      }
      data.recordList = newData;
      const pageBean = Immutable.merge(page(state[field]).append(data));
      return state.merge({ [field]: pageBean });
    },
    resetData: (state, { data }) => {
      return state.merge(data);
    }
  },
  actions: {
    /** 重置数据 */
    resetData: (data = {}) => ({
      type: 'book/resetData',
      data
    }),
    /** 更新收藏列表的list数据，用于修复antd mobile的ListView组件的renderRow不同步更新的问题 */
    updateList: (data, field) => {
      return ({
        type: 'book/update',
        promise: Promise.resolve(data),
        field: field
      });
    },
    /** 跳转小程序开关状态 */
    setRaysSwitchStatus: (data = false) => ({
      type: 'book/update/isRaysOpen',
      promise: Promise.resolve(data),
      field: 'isRaysOpen'
    }),
    /** 搜索图书 */
    getAdviserBooks4Applet: (data) => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getAdviserBooks4Applet(data),
      field: 'searchBookPageBean'
    }),
    /** 收藏书籍 */
    getCollectionList: (data) => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getCollectionList(data),
      field: 'collectionList'
    }),
    /** 我的书架 */
    listUserBookcaseByWechatUserId: (data) => ({
      type: 'book/updatePageBean',
      promise: bookcenter.listUserBookcaseByWechatUserId(data),
      field: 'bookShelfPageBean'
    }),
    /** 系列书 */
    getSeriesBookList: (data) => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getSeriesBookList(data),
      field: 'seriesBookPageBean'
    }),
    /** 开启世间食记系列书 */
    getAllBook4OpenFood: (data) => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getAllBook4OpenFood(data),
      field: 'openFoodLists'
    }),
    /** 为你推荐 */
    getRecommendList: (data) => {
      return ({
        type: 'book/updateRecommendList',
        promise: bookcenter.getRecommendList(data),
        field: 'recommendListPageBean'
      });
    },
    /** 我的足迹 */
    getFootPrintList: (data) => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getFootPrintList(data),
      field: 'footPrintListPageBean'
    }),
    /** 已购资源 */
    getMiniOrderListByWechatUserId: (data) => ({
      type: 'book/updatePageBean',
      promise: tradecenter.getMiniOrderListByWechatUserId(data),
      field: 'myResourcePageBean'
    }),
    getBooklist: data => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getBooklistByGradeLabel4ResourcePage(data),
      field: 'bookListPageBean'
    }),
    listCourseByUser: data => ({
      type: 'book/updatePageBean',
      promise: bookcenter.listCourseByUser(data),
      field: 'coursePageBean'
    }),
    /**资源广场根据模块搜索 */
    getResource4H5: data => ({
      type: 'book/updatePageBean',
      promise: bookcenter.getResource4H5(data),
      field: 'resourcePageBean'
    }),
    /** 客户端获取商品列表 */
    getList4Wechat: data => ({
      type: 'book/update2In1PageBean',
      promise: readercenter.getList4Wechat(data),
      field: 'goodsPageBean'
    }),
    /** 根据书刊id获取年级和是否教辅  */
    getBookGradeLabel: data => ({
      type: 'book/update',
      promise: bookcenter.getBookGradeLabel(data),
      field: 'gradeLabelData'
    }),
    /** 获取小睿伴学应用 */
    getXiaoRuiAppIds: () => ({
      type: 'book/update',
      promise: exercisebook.getCommonConfigByCode({ code: 'XIAO_RUI_APP_IDS' })
        .then(data => {
          return JSON.parse(data.content);
        }),
      field: 'xiaoRuiAppIds'
    }),
    getBookSource: (bookId) => ({
      type: 'book/update',
      promise: exercisebook.getBookBaseSourceByBookId({ bookId }).then(res => {
        return res.sourceType;
      }),
      field: 'bookSourceType'
    })
  }
};